<template>
  <i
    :class="classes"
    :style="styles"
    @click="handleClick"
  />
</template>
<script>
const prefixCls = 'iconfont'
export default {
  name: 'LdIcon',
  componentName: 'LdIcon',
  props: {
    type: {
      type:String,
      default:''
    },
    size: {
      type:[Number, String],
      default:''
    },
    color: {
      type:String,
      default:''
    },
    gradient: {
      type:Boolean,
      default:false
    },
    fontStyle: {
      type: String,
      default:'normal'
    },
    iconClass:{
      type:String,
      default:''
    }
  },
  computed: {
    classes() {
      return `${prefixCls} ${this.type} ${this.gradient ? 'gradient' : ''} ${this.iconClass}`
    },
    styles() {
      let style = {}
      style['font-style'] = 'normal'
      if (this.size) {
        style['font-size'] = `${this.size}px`
      }
      if (this.fontStyle) {
        style['font-style'] = this.fontStyle
      }
      if (this.color) {
        style.color = this.color
      }
      return style
    }
  },
  methods: {
    handleClick(evt) {
      this.$emit('click', evt)
    }
  }
}
</script>

<style lang="less">
@import "iconfont.css";
@import "./icon/iconfont.css";
.gradient {
  font-size: 52rpx;
  -webkit-background-clip: text;
  color:transparent;
}
</style>
